import React from "react";
import { Nav, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("userRole");
    localStorage.removeItem("userEmail");
    navigate("/login");
  };

  return (
    <div
      className="d-flex flex-column flex-shrink-0 text-white"
      style={{
        width: "260px",
        minHeight: "100vh",
        background:
          "linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7))",
        boxShadow: "0 0 15px 0 rgba(34, 41, 47, 0.05)",
        transition: "all 0.3s ease",
        zIndex: 1000,
      }}
    >
      <div
        className="fw-bold text-center rounded-3 my-4 mx-3 py-3"
        style={{
          fontSize: "1.5rem",
          letterSpacing: "1px",
          background: "rgba(255,255,255,0.1)",
          backdropFilter: "blur(5px)",
        }}
      >
        <i className="bi bi-cup-hot-fill me-2"></i>
        <span>UC COFFEE</span>
      </div>

      <Nav defaultActiveKey="/admin" className="flex-column mb-auto mt-3">
        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/admin"
            className={`d-flex align-items-center mx-3 mb-2 rounded-3 fw-semibold ${
              location.pathname === "/admin" ? "active" : ""
            }`}
            style={{
              color: "#fff",
              opacity: location.pathname === "/admin" ? 1 : 0.85,
              padding: "12px 20px",
              transition: "all 0.3s ease",
              background:
                location.pathname === "/admin"
                  ? "rgba(255, 255, 255, 0.15)"
                  : "transparent",
              transform:
                location.pathname === "/admin"
                  ? "translateX(5px)"
                  : "translateX(0)",
              boxShadow:
                location.pathname === "/admin"
                  ? "0 0 10px rgba(0,0,0,0.1)"
                  : "none",
            }}
            onMouseEnter={(e) => {
              if (location.pathname !== "/admin") {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.transform = "translateX(5px)";
                e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
              }
            }}
            onMouseLeave={(e) => {
              if (location.pathname !== "/admin") {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.opacity = "0.85";
                e.currentTarget.style.transform = "translateX(0)";
                e.currentTarget.style.boxShadow = "none";
              }
            }}
          >
            <i className="bi bi-grid-fill me-3 fs-5"></i>
            Dashboard
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/admin/bookings"
            className={`d-flex align-items-center mx-3 mb-2 rounded-3 fw-semibold ${
              location.pathname === "/admin/bookings" ? "active" : ""
            }`}
            style={{
              color: "#fff",
              opacity: location.pathname === "/admin/bookings" ? 1 : 0.85,
              padding: "12px 20px",
              transition: "all 0.3s ease",
              background:
                location.pathname === "/admin/bookings"
                  ? "rgba(255, 255, 255, 0.15)"
                  : "transparent",
              transform:
                location.pathname === "/admin/bookings"
                  ? "translateX(5px)"
                  : "translateX(0)",
              boxShadow:
                location.pathname === "/admin/bookings"
                  ? "0 0 10px rgba(0,0,0,0.1)"
                  : "none",
            }}
            onMouseEnter={(e) => {
              if (location.pathname !== "/admin/bookings") {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.transform = "translateX(5px)";
                e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
              }
            }}
            onMouseLeave={(e) => {
              if (location.pathname !== "/admin/bookings") {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.opacity = "0.85";
                e.currentTarget.style.transform = "translateX(0)";
                e.currentTarget.style.boxShadow = "none";
              }
            }}
          >
            <i className="bi bi-calendar2-check-fill me-3 fs-5"></i>
            Quản lý Đặt bàn
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/admin/users"
            className="d-flex align-items-center mx-3 mb-2 rounded-3 fw-semibold"
            style={{
              color: "#fff",
              opacity: 0.85,
              padding: "12px 20px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
              e.currentTarget.style.opacity = "1";
              e.currentTarget.style.transform = "translateX(5px)";
              e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.opacity = "0.85";
              e.currentTarget.style.transform = "translateX(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <i className="bi bi-people-fill me-3 fs-5"></i>
            Quản lý Users
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/admin/menu"
            className="d-flex align-items-center mx-3 mb-2 rounded-3 fw-semibold"
            style={{
              color: "#fff",
              opacity: 0.85,
              padding: "12px 20px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
              e.currentTarget.style.opacity = "1";
              e.currentTarget.style.transform = "translateX(5px)";
              e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.opacity = "0.85";
              e.currentTarget.style.transform = "translateX(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <i className="bi bi-cup-straw me-3 fs-5"></i>
            Quản lý Menu
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/admin/revenue"
            className="d-flex align-items-center mx-3 mb-2 rounded-3 fw-semibold"
            style={{
              color: "#fff",
              opacity: 0.85,
              padding: "12px 20px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
              e.currentTarget.style.opacity = "1";
              e.currentTarget.style.transform = "translateX(5px)";
              e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.opacity = "0.85";
              e.currentTarget.style.transform = "translateX(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <i className="bi bi-bar-chart-fill me-3 fs-5"></i>
            Doanh thu
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            href="#"
            className="d-flex align-items-center mx-3 mb-2 rounded-3 fw-semibold"
            style={{
              color: "#fff",
              opacity: 0.85,
              padding: "12px 20px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
              e.currentTarget.style.opacity = "1";
              e.currentTarget.style.transform = "translateX(5px)";
              e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.opacity = "0.85";
              e.currentTarget.style.transform = "translateX(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <i className="bi bi-gear-fill me-3 fs-5"></i>
            Cài đặt
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <div
        className="p-3 mx-2 mb-3 rounded"
        style={{ background: "rgba(255,255,255,0.1)" }}
      >
        <div className="d-flex align-items-center text-white mb-3">
          <img
            src="https://ui-avatars.com/api/?name=Admin+Master&background=random&color=fff"
            alt=""
            width="40"
            height="40"
            className="rounded-circle me-3 shadow-sm border border-2 border-white"
          />
          <div>
            <div className="fw-bold">Admin Master</div>
            <small className="opacity-75" style={{ fontSize: "0.75rem" }}>
              Super Admin
            </small>
          </div>
        </div>
        <Button
          variant="light"
          size="sm"
          className="w-100 rounded-3"
          onClick={handleLogout}
        >
          <i className="bi bi-box-arrow-right me-2"></i>
          Đăng xuất
        </Button>
      </div>
    </div>
  );
}

export default AdminSidebar;
